module.exports = __webpack_public_path__ + "static/poster-1-314db1c9826952c32a5550aec47dca36.jpg";